import script from "./DataGroupShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataGroupShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./DataGroupShareModal.vue?vue&type=style&index=0&id=719ab004&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-719ab004"]])

export default __exports__